var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M29.565 24H2.435A2.437 2.437 0 0 1 0 21.565V2.435A2.437 2.437 0 0 1 2.435 0h27.13A2.437 2.437 0 0 1 32 2.435v19.13A2.437 2.437 0 0 1 29.565 24zM2.435 2A.435.435 0 0 0 2 2.435v19.13c0 .24.195.435.435.435h27.13c.24 0 .435-.195.435-.435V2.435A.435.435 0 0 0 29.565 2H2.435z", fill: "#CCC", fillRule: "nonzero" }),
      React.createElement("path", { fill: "#CCC", fillRule: "nonzero", d: "M1 6.333h30v4H1z" }),
      React.createElement("circle", { stroke: "#FFBFF4", strokeWidth: "2", fill: "#FFF", cx: "23.5", cy: "9.5", r: "4.5" }),
      React.createElement("path", { d: "M11.824 16.043H5a1 1 0 1 1 0-2h6.824a1 1 0 1 1 0 2zm-3.412 3.75H5a1 1 0 1 1 0-2h3.412a1 1 0 1 1 0 2z", fill: "#CCC", fillRule: "nonzero" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/apps/payment/components/CreditCardForm/cvv.svg